import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import it from './locales/it.json'
import es from './locales/es.json'
import fr from './locales/fr.json'
import de from './locales/de.json'
import pl from './locales/pl.json'

const messages = {
  en,
  it,
  es,
  fr,
  de,
  pl
}

const getBrowserLocale = () => {
  const savedLocale = localStorage.getItem('appLanguage')
  if (savedLocale && Object.keys(messages).includes(savedLocale)) {
    return savedLocale
  }
  const navigatorLocale =
    navigator.languages && navigator.languages.length
      ? navigator.languages[0]
      : navigator.language || navigator.userLanguage

  if (!navigatorLocale) return 'en'

  const lang = navigatorLocale.split('-')[0]

  if (Object.keys(messages).includes(lang)) {
    return lang
  }

  return 'en'
}

const i18n = createI18n({
  legacy: false, // Use Composition API
  locale: getBrowserLocale(),
  fallbackLocale: 'en',
  messages
})

export default i18n
